export const SET_USERS = 'SET_USERS'
export const UPDATE_USER = 'UPDATE_USER'
export const REMOVE_USER = 'REMOVE_USER'

export const SET_ACTIVE_USERS = 'SET_ACTIVE_USERS'
export const UPDATE_ACTIVE_USER = 'UPDATE_ACTIVE_USER'
export const REMOVE_ACTIVE_USER = 'REMOVE_ACTIVE_USER'